import { MentorshipStatusEnum } from '@juno/client-api/model';

export interface AdditionalFilter {
  id: number;
  type: number; // id of the additional filter option it belongs to
  value: string;
}

export interface MentorshipFilter {
  value: MentorshipStatusEnum;
  label: string;
}

export const MAX_FILTERS_LIMIT = 20;
